import React from "react";
import logo from "../images/logo.svg";
import fb from "../images/icon-facebook.svg";
import twitter from "../images/icon-twitter.svg";
import pinterest from "../images/icon-pinterest.svg";
import instagram from "../images/icon-instagram.svg";

export const Footer = () => {
  return (
    <>
      <div className="footercontainer">
        <div className="footerbar">
          <img src={logo} id="logo" alt="nothing" />

          <div className="iconcontainer">
            <img src={fb} id="fb" alt="nothing" />
            <img src={twitter} id="twitter" alt="nothing" />
            <img src={pinterest} id="pinterest" alt="nothing" />
            <img src={instagram} id="instagram" alt="nothing" />
          </div>
        </div>
        <hr />

        <div className="footerComponentsContainer">
          <div className="ourCompany">
            <p>OUR COMPANY</p>
            <p>HOW WE WORK</p>
            <p>WHY INSURE</p>
            <p>VIEW PLANS</p>
            <p>REVIEWS</p>
          </div>
          <div className="helpMe">
            <p>HELP ME</p>
            <p>FAQ</p>
            <p>TERMS OF USE</p>
            <p>PRIVACY POLICY</p>
            <p>COOKIES</p>
          </div>
          <div className="contact">
            <p>CONTACT</p>
            <p>SALES</p>
            <p>SUPPORT</p>
            <p>LIVE CHAT</p>
          </div>
          <div className="others">
            <p>OTHERS</p>
            <p>CAREERS</p>
            <p>PRESS</p>
            <p>LICENSES</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
